function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        catch: function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: _regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}
function _regeneratorAsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine2(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2(e, r, n, t);
}
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
import { getSideAxis as L, getAlignmentAxis as H, getSide as F, getAlignment as C, getAxisLength as J, evaluate as _, getOppositePlacement as K, getExpandedPlacements as N, getOppositeAxisPlacements as Q, getAlignmentSides as q, getPaddingObject as U, rectToClientRect as I, placements as X, getOppositeAlignmentPlacement as W } from "../../../../../@floating-ui_utils@0.2.9/node_modules/@floating-ui/utils/dist/floating-ui.utils.js";
function Y(n, l, f) {
  var t = n.reference,
    e = n.floating;
  var i = L(l),
    c = H(l),
    a = J(c),
    w = F(l),
    p = i === "y",
    g = t.x + t.width / 2 - e.width / 2,
    r = t.y + t.height / 2 - e.height / 2,
    d = t[a] / 2 - e[a] / 2;
  var o;
  switch (w) {
    case "top":
      o = {
        x: g,
        y: t.y - e.height
      };
      break;
    case "bottom":
      o = {
        x: g,
        y: t.y + t.height
      };
      break;
    case "right":
      o = {
        x: t.x + t.width,
        y: r
      };
      break;
    case "left":
      o = {
        x: t.x - e.width,
        y: r
      };
      break;
    default:
      o = {
        x: t.x,
        y: t.y
      };
  }
  switch (C(l)) {
    case "start":
      o[c] -= d * (f && p ? -1 : 1);
      break;
    case "end":
      o[c] += d * (f && p ? -1 : 1);
      break;
  }
  return o;
}
var te = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(n, l, f) {
    var _f$placement, t, _f$strategy, e, _f$middleware, i, c, a, w, p, _Y, g, r, d, o, x, h, _Y2, _a$h, y, v, _yield$v, u, P, b, s;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _f$placement = f.placement;
          t = _f$placement === void 0 ? "bottom" : _f$placement;
          _f$strategy = f.strategy;
          e = _f$strategy === void 0 ? "absolute" : _f$strategy;
          _f$middleware = f.middleware;
          i = _f$middleware === void 0 ? [] : _f$middleware;
          c = f.platform;
          a = i.filter(Boolean);
          _context.next = 10;
          return c.isRTL == null ? void 0 : c.isRTL(l);
        case 10:
          w = _context.sent;
          _context.next = 13;
          return c.getElementRects({
            reference: n,
            floating: l,
            strategy: e
          });
        case 13:
          p = _context.sent;
          _Y = Y(p, t, w);
          g = _Y.x;
          r = _Y.y;
          d = t;
          o = {};
          x = 0;
          h = 0;
        case 21:
          if (!(h < a.length)) {
            _context.next = 56;
            break;
          }
          _a$h = a[h];
          y = _a$h.name;
          v = _a$h.fn;
          _context.next = 27;
          return v({
            x: g,
            y: r,
            initialPlacement: t,
            placement: d,
            strategy: e,
            middlewareData: o,
            rects: p,
            platform: c,
            elements: {
              reference: n,
              floating: l
            }
          });
        case 27:
          _yield$v = _context.sent;
          u = _yield$v.x;
          P = _yield$v.y;
          b = _yield$v.data;
          s = _yield$v.reset;
          g = u !== null && u !== void 0 ? u : g;
          r = P !== null && P !== void 0 ? P : r;
          o = _objectSpread(_objectSpread({}, o), {}, _defineProperty({}, y, _objectSpread(_objectSpread({}, o[y]), b)));
          _context.t0 = s && x <= 50;
          if (!_context.t0) {
            _context.next = 53;
            break;
          }
          x++;
          _context.t1 = _typeof(s) == "object";
          if (!_context.t1) {
            _context.next = 52;
            break;
          }
          s.placement && (d = s.placement);
          _context.t2 = s.rects;
          if (!_context.t2) {
            _context.next = 51;
            break;
          }
          if (!(s.rects === !0)) {
            _context.next = 49;
            break;
          }
          _context.next = 46;
          return c.getElementRects({
            reference: n,
            floating: l,
            strategy: e
          });
        case 46:
          _context.t3 = _context.sent;
          _context.next = 50;
          break;
        case 49:
          _context.t3 = s.rects;
        case 50:
          p = _context.t3;
        case 51:
          _Y2 = Y(p, d, w), g = _Y2.x, r = _Y2.y, _Y2;
        case 52:
          h = -1;
        case 53:
          h++;
          _context.next = 21;
          break;
        case 56:
          return _context.abrupt("return", {
            x: g,
            y: r,
            placement: d,
            strategy: e,
            middlewareData: o
          });
        case 57:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function te(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
function z(_x4, _x5) {
  return _z.apply(this, arguments);
}
function _z() {
  _z = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(n, l) {
    var f, t, e, i, c, a, w, _ref4, _ref4$boundary, p, _ref4$rootBoundary, g, _ref4$elementContext, r, _ref4$altBoundary, d, _ref4$padding, o, x, y, v, u, P, b, s;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          l === void 0 && (l = {});
          t = n.x;
          e = n.y;
          i = n.platform;
          c = n.rects;
          a = n.elements;
          w = n.strategy;
          _ref4 = _(l, n);
          _ref4$boundary = _ref4.boundary;
          p = _ref4$boundary === void 0 ? "clippingAncestors" : _ref4$boundary;
          _ref4$rootBoundary = _ref4.rootBoundary;
          g = _ref4$rootBoundary === void 0 ? "viewport" : _ref4$rootBoundary;
          _ref4$elementContext = _ref4.elementContext;
          r = _ref4$elementContext === void 0 ? "floating" : _ref4$elementContext;
          _ref4$altBoundary = _ref4.altBoundary;
          d = _ref4$altBoundary === void 0 ? !1 : _ref4$altBoundary;
          _ref4$padding = _ref4.padding;
          o = _ref4$padding === void 0 ? 0 : _ref4$padding;
          x = U(o);
          y = a[d ? r === "floating" ? "reference" : "floating" : r];
          _context4.t0 = I;
          _context4.t1 = i;
          _context4.next = 24;
          return i.isElement == null ? void 0 : i.isElement(y);
        case 24:
          _context4.t3 = f = _context4.sent;
          _context4.t2 = _context4.t3 == null;
          if (_context4.t2) {
            _context4.next = 28;
            break;
          }
          _context4.t2 = f;
        case 28:
          if (!_context4.t2) {
            _context4.next = 32;
            break;
          }
          _context4.t4 = y;
          _context4.next = 38;
          break;
        case 32:
          _context4.t5 = y.contextElement;
          if (_context4.t5) {
            _context4.next = 37;
            break;
          }
          _context4.next = 36;
          return i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating);
        case 36:
          _context4.t5 = _context4.sent;
        case 37:
          _context4.t4 = _context4.t5;
        case 38:
          _context4.t6 = _context4.t4;
          _context4.t7 = p;
          _context4.t8 = g;
          _context4.t9 = w;
          _context4.t10 = {
            element: _context4.t6,
            boundary: _context4.t7,
            rootBoundary: _context4.t8,
            strategy: _context4.t9
          };
          _context4.next = 45;
          return _context4.t1.getClippingRect.call(_context4.t1, _context4.t10);
        case 45:
          _context4.t11 = _context4.sent;
          v = (0, _context4.t0)(_context4.t11);
          u = r === "floating" ? {
            x: t,
            y: e,
            width: c.floating.width,
            height: c.floating.height
          } : c.reference;
          _context4.next = 50;
          return i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating);
        case 50:
          P = _context4.sent;
          _context4.next = 53;
          return i.isElement == null ? void 0 : i.isElement(P);
        case 53:
          if (!_context4.sent) {
            _context4.next = 62;
            break;
          }
          _context4.next = 56;
          return i.getScale == null ? void 0 : i.getScale(P);
        case 56:
          _context4.t13 = _context4.sent;
          if (_context4.t13) {
            _context4.next = 59;
            break;
          }
          _context4.t13 = {
            x: 1,
            y: 1
          };
        case 59:
          _context4.t12 = _context4.t13;
          _context4.next = 63;
          break;
        case 62:
          _context4.t12 = {
            x: 1,
            y: 1
          };
        case 63:
          b = _context4.t12;
          _context4.t14 = I;
          if (!i.convertOffsetParentRelativeRectToViewportRelativeRect) {
            _context4.next = 71;
            break;
          }
          _context4.next = 68;
          return i.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: a,
            rect: u,
            offsetParent: P,
            strategy: w
          });
        case 68:
          _context4.t15 = _context4.sent;
          _context4.next = 72;
          break;
        case 71:
          _context4.t15 = u;
        case 72:
          _context4.t16 = _context4.t15;
          s = (0, _context4.t14)(_context4.t16);
          return _context4.abrupt("return", {
            top: (v.top - s.top + x.top) / b.y,
            bottom: (s.bottom - v.bottom + x.bottom) / b.y,
            left: (v.left - s.left + x.left) / b.x,
            right: (s.right - v.right + x.right) / b.x
          });
        case 75:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _z.apply(this, arguments);
}
function Z(n, l, f) {
  return (n ? [].concat(_toConsumableArray(f.filter(function (e) {
    return C(e) === n;
  })), _toConsumableArray(f.filter(function (e) {
    return C(e) !== n;
  }))) : f.filter(function (e) {
    return F(e) === e;
  })).filter(function (e) {
    return n ? C(e) === n || (l ? W(e) !== e : !1) : !0;
  });
}
var ne = function ne(n) {
    return n === void 0 && (n = {}), {
      name: "autoPlacement",
      options: n,
      fn: function fn(l) {
        return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var f, t, e, i, c, a, w, p, _ref2, _ref2$crossAxis, g, r, _ref2$allowedPlacemen, d, _ref2$autoAlignment, o, x, h, y, v, u, P, b, s, T, B, S;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                i = l.rects;
                c = l.middlewareData;
                a = l.placement;
                w = l.platform;
                p = l.elements;
                _ref2 = _(n, l);
                _ref2$crossAxis = _ref2.crossAxis;
                g = _ref2$crossAxis === void 0 ? !1 : _ref2$crossAxis;
                r = _ref2.alignment;
                _ref2$allowedPlacemen = _ref2.allowedPlacements;
                d = _ref2$allowedPlacemen === void 0 ? X : _ref2$allowedPlacemen;
                _ref2$autoAlignment = _ref2.autoAlignment;
                o = _ref2$autoAlignment === void 0 ? !0 : _ref2$autoAlignment;
                x = _objectWithoutProperties(_ref2, ["crossAxis", "alignment", "allowedPlacements", "autoAlignment"]);
                h = r !== void 0 || d === X ? Z(r || null, o, d) : d;
                _context2.next = 17;
                return z(l, x);
              case 17:
                y = _context2.sent;
                v = ((f = c.autoPlacement) == null ? void 0 : f.index) || 0;
                u = h[v];
                if (!(u == null)) {
                  _context2.next = 22;
                  break;
                }
                return _context2.abrupt("return", {});
              case 22:
                _context2.t0 = q;
                _context2.t1 = u;
                _context2.t2 = i;
                _context2.next = 27;
                return w.isRTL == null ? void 0 : w.isRTL(p.floating);
              case 27:
                _context2.t3 = _context2.sent;
                P = (0, _context2.t0)(_context2.t1, _context2.t2, _context2.t3);
                if (!(a !== u)) {
                  _context2.next = 31;
                  break;
                }
                return _context2.abrupt("return", {
                  reset: {
                    placement: h[0]
                  }
                });
              case 31:
                b = [y[F(u)], y[P[0]], y[P[1]]], s = [].concat(_toConsumableArray(((t = c.autoPlacement) == null ? void 0 : t.overflows) || []), [{
                  placement: u,
                  overflows: b
                }]), T = h[v + 1];
                if (!T) {
                  _context2.next = 34;
                  break;
                }
                return _context2.abrupt("return", {
                  data: {
                    index: v + 1,
                    overflows: s
                  },
                  reset: {
                    placement: T
                  }
                });
              case 34:
                B = s.map(function (m) {
                  var O = C(m.placement);
                  return [m.placement, O && g ? m.overflows.slice(0, 2).reduce(function (j, M) {
                    return j + M;
                  }, 0) : m.overflows[0], m.overflows];
                }).sort(function (m, O) {
                  return m[1] - O[1];
                }), S = ((e = B.filter(function (m) {
                  return m[2].slice(0, C(m[0]) ? 2 : 3).every(function (O) {
                    return O <= 0;
                  });
                })[0]) == null ? void 0 : e[0]) || B[0][0];
                return _context2.abrupt("return", S !== a ? {
                  data: {
                    index: v + 1,
                    overflows: s
                  },
                  reset: {
                    placement: S
                  }
                } : {});
              case 36:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))();
      }
    };
  },
  le = function le(n) {
    return n === void 0 && (n = {}), {
      name: "flip",
      options: n,
      fn: function fn(l) {
        return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          var f, t, e, i, c, a, w, p, _ref3, _ref3$mainAxis, g, _ref3$crossAxis, r, d, _ref3$fallbackStrateg, o, _ref3$fallbackAxisSid, x, _ref3$flipAlignment, h, y, v, u, P, b, s, T, B, $, S, m, k, O, j, _k, V, D, M, E;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                e = l.placement, i = l.middlewareData, c = l.rects, a = l.initialPlacement, w = l.platform, p = l.elements, _ref3 = _(n, l), _ref3$mainAxis = _ref3.mainAxis, g = _ref3$mainAxis === void 0 ? !0 : _ref3$mainAxis, _ref3$crossAxis = _ref3.crossAxis, r = _ref3$crossAxis === void 0 ? !0 : _ref3$crossAxis, d = _ref3.fallbackPlacements, _ref3$fallbackStrateg = _ref3.fallbackStrategy, o = _ref3$fallbackStrateg === void 0 ? "bestFit" : _ref3$fallbackStrateg, _ref3$fallbackAxisSid = _ref3.fallbackAxisSideDirection, x = _ref3$fallbackAxisSid === void 0 ? "none" : _ref3$fallbackAxisSid, _ref3$flipAlignment = _ref3.flipAlignment, h = _ref3$flipAlignment === void 0 ? !0 : _ref3$flipAlignment, y = _objectWithoutProperties(_ref3, ["mainAxis", "crossAxis", "fallbackPlacements", "fallbackStrategy", "fallbackAxisSideDirection", "flipAlignment"]);
                if (!((f = i.arrow) != null && f.alignmentOffset)) {
                  _context3.next = 3;
                  break;
                }
                return _context3.abrupt("return", {});
              case 3:
                v = F(e);
                u = L(a);
                P = F(a) === a;
                _context3.next = 8;
                return w.isRTL == null ? void 0 : w.isRTL(p.floating);
              case 8:
                b = _context3.sent;
                s = d || (P || !h ? [K(a)] : N(a));
                T = x !== "none";
                !d && T && s.push.apply(s, _toConsumableArray(Q(a, h, x, b)));
                B = [a].concat(_toConsumableArray(s));
                _context3.next = 15;
                return z(l, y);
              case 15:
                $ = _context3.sent;
                S = [];
                m = ((t = i.flip) == null ? void 0 : t.overflows) || [];
                if (g && S.push($[v]), r) {
                  k = q(e, c, b);
                  S.push($[k[0]], $[k[1]]);
                }
                if (!(m = [].concat(_toConsumableArray(m), [{
                  placement: e,
                  overflows: S
                }]), !S.every(function (k) {
                  return k <= 0;
                }))) {
                  _context3.next = 35;
                  break;
                }
                _k = (((O = i.flip) == null ? void 0 : O.index) || 0) + 1, V = B[_k];
                if (!(V && (!(r === "alignment" ? u !== L(V) : !1) || m.every(function (A) {
                  return A.overflows[0] > 0 && L(A.placement) === u;
                })))) {
                  _context3.next = 23;
                  break;
                }
                return _context3.abrupt("return", {
                  data: {
                    index: _k,
                    overflows: m
                  },
                  reset: {
                    placement: V
                  }
                });
              case 23:
                D = (j = m.filter(function (E) {
                  return E.overflows[0] <= 0;
                }).sort(function (E, A) {
                  return E.overflows[1] - A.overflows[1];
                })[0]) == null ? void 0 : j.placement;
                if (D) {
                  _context3.next = 33;
                  break;
                }
                _context3.t0 = o;
                _context3.next = _context3.t0 === "bestFit" ? 28 : _context3.t0 === "initialPlacement" ? 31 : 33;
                break;
              case 28:
                E = (M = m.filter(function (A) {
                  if (T) {
                    var R = L(A.placement);
                    return R === u || R === "y";
                  }
                  return !0;
                }).map(function (A) {
                  return [A.placement, A.overflows.filter(function (R) {
                    return R > 0;
                  }).reduce(function (R, G) {
                    return R + G;
                  }, 0)];
                }).sort(function (A, R) {
                  return A[1] - R[1];
                })[0]) == null ? void 0 : M[0];
                E && (D = E);
                return _context3.abrupt("break", 33);
              case 31:
                D = a;
                return _context3.abrupt("break", 33);
              case 33:
                if (!(e !== D)) {
                  _context3.next = 35;
                  break;
                }
                return _context3.abrupt("return", {
                  reset: {
                    placement: D
                  }
                });
              case 35:
                return _context3.abrupt("return", {});
              case 36:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }))();
      }
    };
  };
export { ne as autoPlacement, te as computePosition, z as detectOverflow, le as flip, I as rectToClientRect };